import ButtonAdd from "../../components/buttonAdd/ButtonAdd";
import ResponseIntentNode from "../../components/responses/ResponseIntentNode";
import TitleIntentNode from "../../components/TitleIntentNode";
import { PhraseIntentNode } from "../../components/inputs/PhraseIntentNode";
import { EventIntentNode } from "../../components/inputs/EventIntentNode";
import { ContextInputIntentNode } from "../../components/inputs/ContextInputIntentNode";
import { ContextOutputIntentNode } from "../../components/responses/ContextOutputIntentNode";
import { ConditionalResponsesIntentNode } from "../../components/responses/ConditionalResponsesIntentNode";
import { ResponsePhrasesIntentNode } from "../../components/responses/ResponsePhrasesIntentNode";

import EntryIntentNode from "../../components/inputs/EntryIntentNode";
import ParameterIntentNode from "../../components/params/ParameterNode/ParameterIntentNode";
import ExtensionIntentNode from "../../components/extensions/ExtensionsNode/ExtensionIntentNode";
import { ParameterConfigIntentNode } from "../../components/params/ParameterNode/ParameterConfigIntentNode";
import { ExtensionConfigIntentNode } from "../../components/extensions/ExtensionsNode/ExtensionConfigIntentNode";
import DefaultResponseNode from "../../components/DefaultResponseNode";
import DescriptionNode from "../../components/DescriptionNode";
import { VariablesFlow } from "../../components/extensions/ExtensionsNode/components/VariablesFlow.js";
import IntegrationIntentNode from "../../components/integration/IntegrationConfigNode/IntegrationsIntentNode/IntegrationIntentNode";
import { typesNodes } from "./typesNodes";
import { ButtonAddParams } from "../../components/params/ParameterNode/components/ButtonAddParams";
import { ButtonAddExtensions } from "../../components/extensions/ExtensionsNode/ExtensionIntentNode/components/ButtonAddExtensions";
import { ButtonAddExtension } from "../../components/extensions/ExtensionsNode/ExtensionConfigIntentNode/components/ButtonAddExtension";
import IntegrationConfigIntentNode from "../../components/integration/IntegrationConfigNode/IntegrationsIntentNode/IntegrationConfigIntentNode";
import ButtonAddNodeEdge from "../../components/buttonAdd/ButtonAddNodeEdge";

export const nodeTypes = {
  [typesNodes.title]: TitleIntentNode,
  [typesNodes.entry]: EntryIntentNode,
  [typesNodes.contextInput]: ContextInputIntentNode,
  [typesNodes.phrasesInput]: PhraseIntentNode,
  [typesNodes.event]: EventIntentNode,
  [typesNodes.response]: ResponseIntentNode,
  [typesNodes.contextOutput]: ContextOutputIntentNode,
  [typesNodes.conditionalResponses]: ConditionalResponsesIntentNode,
  [typesNodes.responsePhrases]: ResponsePhrasesIntentNode,
  [typesNodes.parameter]: ParameterIntentNode,
  [typesNodes.parameterConfig]: ParameterConfigIntentNode,
  [typesNodes.extension]: ExtensionIntentNode,
  [typesNodes.extensionConfig]: ExtensionConfigIntentNode,
  [typesNodes.extensionsVariablesFlow]: VariablesFlow,
  [typesNodes.buttonAddExtensions]: ButtonAddExtensions,
  [typesNodes.integration]: IntegrationIntentNode,
  [typesNodes.integrationConfig]: IntegrationConfigIntentNode,
  [typesNodes.description]: DescriptionNode,
  [typesNodes.defaultResponse]: DefaultResponseNode,
  [typesNodes.buttonAdd]: ButtonAdd,
  [typesNodes.addButton]: ButtonAddNodeEdge,
  [typesNodes.buttonAddParams]: ButtonAddParams,
  [typesNodes.buttonAddExtension]: ButtonAddExtension,
};
